import Color from "color";
import { WidgetNoteStyleLegcyToNewBG } from "./useNoteWidgetStyle";

export const pageForegroundColor = (
  page:
    | "ADD"
    | {
        image?: any;
        backgroundColor?: string | null;
        fontColor?: string | null;
      }
) => {
  if (page === "ADD") {
    return "DARK";
  }
  if (page.image) {
    if (page.fontColor) {
      return Color(page.fontColor).isDark() ? "DARK" : "LIGHT";
    }

    return "LIGHT";
  }

  if (
    page.backgroundColor &&
    Color(
      WidgetNoteStyleLegcyToNewBG[page.backgroundColor] ?? page.backgroundColor
    ).isDark()
  ) {
    return "LIGHT";
  }
  return "DARK";
};
